// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app';
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/firebase-functions';
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
const firebaseConfig = {
  apiKey: 'AIzaSyCWqcxmzQ3OREIV6J_vfEppFgIQJ8mcxEY',
  authDomain: 'sld-2021.firebaseapp.com',
  projectId: 'sld-2021',
  storageBucket: 'sld-2021.appspot.com',
  messagingSenderId: '145911329182',
  appId: '1:145911329182:web:15f1a4b4e5fc871f18a68f',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

firebase.firestore();
export default firebase;
